
// Código elaborado por: Nelson Braga
// Cargo: Desenvolvedor Fullstack
// Data: 22/03/2024

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import { BrowserRouter } from 'react-router-dom'
import { ContextoProvider } from './providers/Contexto';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ContextoProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ContextoProvider>
);